<template>
  <div class="inner">
    <h2 class="fz-20 d-flex border-bottom mt-0">{{ $t('構成部品表') }}</h2>
      <div class="d-flex justify-content-start mt-4 mb-4">
        <button
          type="button"
          class="btn btn-success create-btn mr-3"
          @click="csvModalOpen('structure')"
        >
          {{ $t('csv取込') }}
        </button>
        <button
          type="button"
          class="btn btn-success create-btn mr-3"
          @click="mixinTransition('/structure-import/index.html')"
        >
          {{ $t('csv取込設定ページに移動') }}
        </button>
        <button
          type="button"
          class="btn btn-success create-btn"
          @click="csvDownload()"
        >
          {{ $t('csvダウンロード') }}
        </button>
    </div>
    <div
    id="componentPartsDrawing-parent">
      <div class="card">
        <div class="accordion card-header d-flex justify-content-between" id="componentPartsDrawing-header" data-toggle="collapse" data-target="#componentPartsDrawing" :aria-expanded="false" aria-controls="componentPartsDrawing">
          <h3 class="mb-0">{{ $t('構成部品表') }}</h3>
          <div class="accordion-toggle-btn">
            <b-button block id="componentPartsDrawing-up">{{ $t('閉じる') }}</b-button>
            <b-button block id="componentPartsDrawing-down">{{ $t('開く') }}</b-button>
          </div>
        </div>
        <div id="componentPartsDrawing" class="collapse" aria-labelledby="componentPartsDrawing-header" data-parent="#componentPartsDrawing-parent">
          <div class="card-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="table-active text-left w-15">{{ $t('品番') }}</th>
                  <th class="table-active text-left w-15">{{ $t('品名') }}</th>
                  <th class="table-active text-left w-15">{{ $t('親品番') }}</th>
                  <th class="table-active text-left w-15">{{ $t('親品名') }}</th>
                  <th class="table-active text-left w-5">{{ $t('階層') }}</th>
                  <th class="table-active text-left w-5">{{ $t('数量') }}</th>
                  <th class="table-active text-left w-10">{{ $t('単位') }}</th>
                  <th class="table-active text-left w-20">{{ $t('使用工程') }}</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr>
                  <td>
                    {{ structures.productCode || '-' }}
                  </td>
                  <td>
                    {{ structures.productName || '-' }}
                  </td>
                  <td>-</td>
                  <td>-</td>
                  <td>0</td>
                  <td>1</td>
                  <td>
                    {{ structures.outputLevel || '-' }}
                  </td>
                  <td>-</td>
                </tr>
                <tr v-for="(item, index) in shapingOneArray" :key="index">
                  <td>
                    {{ item.productCode || '-' }}
                  </td>
                  <td>
                    {{ item.productName || '-' }}
                  </td>
                  <td>
                    {{ item.parentProductCode || '-' }}
                  </td>
                  <td>
                    {{ item.parentProductName || '-' }}
                  </td>
                  <td>
                    <template v-if="!isEmpty(item.level)">
                      {{ item.level }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td>
                    <template v-if="!isEmpty(item.quantity)">
                      {{ item.quantity }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <td>
                    {{ item.outputLevel || '-' }}
                  </td>
                  <td>
                    <template v-if="!isEmpty(item.productProcessId)">
                      {{item.productProcessSort}}.{{ $t(item.productProcessName) }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-start mt-3 mb-5">
      <button
        type="button"
        class="btn btn-light create-btn mr-3"
        @click="modalOpen()"
      >
        {{ $t('編集') }}
      </button>
      <button
        type="button"
        class="btn btn-success create-btn"
        @click="constitutionLink()"
      >
        {{ $t('構成部品表ページに移動') }}
      </button>
    </div>
    <component-parts-modal
    ref="componentParts"
    :structures="structures"
    :processes="processes"
    :processKinds="processKinds"
    @modalClose="modalClose()"
    @registered="registered()"
    ></component-parts-modal>
    <csv-modal
    ref="csv"
    ></csv-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import componentPartsModal from './componentPartsModal'
import csvModal from './csvModal'
export default {
  props: {
    productId: {
      type: Number,
      required: true,
      default: 0,
    },
    structures: {
      type: Object,
      required: true,
      default: () => {},
    },
    processes: {
      type: Array,
      required: true,
      default: () => [],
    },
    processKinds: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: {
    componentPartsModal,
    csvModal,
  },
  data() {
    return {
    }
  },
  mounted() {
    const up = document.getElementById('componentPartsDrawing-up')
    const down = document.getElementById('componentPartsDrawing-down')
    up.classList.add('is-hide')
    down.classList.add('is-show')
    $('#componentPartsDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('componentPartsDrawing-up')
      const down = document.getElementById('componentPartsDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#componentPartsDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('componentPartsDrawing-up')
      const down = document.getElementById('componentPartsDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
  },
  methods: {
    // 構成部品の編集モーダルを表示
    modalOpen() {
      this.$refs.componentParts.modalOpen()
    },
    // csvのimportするモーダルを表示
    csvModalOpen(type) {
      this.$refs.csv.modalOpen(type)
    },
    // 構成部品の編集が完了した時の処理
    registered() {
      this.$emit('registered')
    },
    // 構成部品モーダルが閉じた時の処理
    modalClose() {
      this.$emit('modalClose')
    },
    // 構成部品に遷移
    constitutionLink() {
      let params = {}
      params.productId = this.productId
      window.location.href = process.env.NODE_ENV !== 'development' ? `/base/constitution/index.html?${this.mixinGetUrlParams(params)}` : `/constitution/index.html?${this.mixinGetUrlParams(params)}`
    },
    // csvをダウンロードする
    async csvDownload() {
      try {
        const res = await this.$axios.post(
          `${this.$appConfig.CommonApiUrl}/download`,
          { productId: this.productId, type: 'structure' },
          {
            // responseType: 'blob',
            // dataType:'binary',
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.mixinDownloadCsvBlob(res.data, 'structure.csv')
      } catch (e) {
        // Do nothing
      }
    },
  },
  computed: {
    shapingOneArray() {
      let oneArray = []
      const arrayMap = (item, level) => {
        level++
        item.structures.map(structure => {
          structure.level = level
          oneArray.push(structure)
          if (structure.structures.length !== 0) arrayMap(structure, level)
        })
        if (level > 0) level--
      }
      if (!this.structures.productId) return []
      arrayMap(this.mixin_deepcopy(this.structures), 0)
      return oneArray
    },
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
  watch: {
    'structures': {
      handler: function(newVal) {
        if (newVal.structures.length < 1) {
          $('#componentPartsDrawing').collapse('hide')
        } else {
          $('#componentPartsDrawing').collapse('show')
        }
      },
      deep: true,
    },
  },
}
</script>

<style>

</style>
